import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * One page of a project's activity feed, newest first. `before` is the
 * `nextBefore` cursor of the previous page (omit it for the newest rows).
 * The backend enforces the activity_log_view permission and looks up the
 * project's business_id. Returns the API payload (`{ items, nextBefore }`).
 */
export const getProjectActivityFeed = async ({
  projectId,
  limit,
  before,
  activeEmployerInfo = {},
}) => {
  const query = [
    limit ? `limit=${encodeURIComponent(limit)}` : null,
    before ? `before=${encodeURIComponent(before)}` : null,
  ]
    .filter(Boolean)
    .join('&');
  const apiPath = `activity-log/project/${projectId}/feed${
    query ? `?${query}` : ''
  }`;

  const { activeEmployerId, activeEmployerBusinessId } = activeEmployerInfo;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      ...(activeEmployerId && { 'X-Active-Employer-Id': activeEmployerId }),
      ...(activeEmployerBusinessId && {
        'X-Active-Employer-Business-Id': activeEmployerBusinessId,
      }),
    },
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
